export default "__VITE_ASSET__26301b3b__"